import { Pagination } from "src/app/services/response-models/pagination.response.model";

export class LoadTimeEntryTypesPagination {
    static readonly type = "[Time Entry Types] Load pagination";

    constructor(public payload: Pagination) {}
}
